import React, { useCallback } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import { TextField as FormikTextField } from "formik-mui";
import FormikRemoteAutocompleteField from "../../MasterData/components/FormikRemoteAutocompleteField";
import { mastersApi } from "../../../../services/MasterDataServices";

export default function TicketTypeFormDialog({
  open,
  onClose,
  editingItem,
  validationSchema,
  onSubmit,
}) {
  const loadMuseumTypes = useCallback(() => mastersApi("museum_types", "get"), []);
  const loadVisitorTypes = useCallback(() => mastersApi("visitor_types", "get"), []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editingItem ? "Edit Ticket Fee" : "Add Ticket Fee"}</DialogTitle>
      <Formik
        initialValues={{
          code: editingItem?.code || "",
          name: editingItem?.name || "",
          description: editingItem?.description || "",
          museum_type_id: editingItem?.museum_type?.id || "",
          visitor_type_id: editingItem?.visitor_type?.id || "",
          fee: editingItem?.fee ?? "",
          status: editingItem?.status || "active",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormikRemoteAutocompleteField
                    name={"museum_type_id"}
                    label={"Museum Type"}
                    loadOptions={loadMuseumTypes}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikRemoteAutocompleteField
                    name={"visitor_type_id"}
                    label={"Visitor Type"}
                    loadOptions={loadVisitorTypes}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FormikTextField}
                    name="name"
                    label="Ticket Fee Name"
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FormikTextField}
                    name="code"
                    label="Code"
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FormikTextField}
                    name="fee"
                    label="Fee"
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="number"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FormikTextField}
                    name="status"
                    label="Status"
                    fullWidth
                    variant="outlined"
                    size="small"
                    select
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={FormikTextField}
                    name="description"
                    label="Description"
                    fullWidth
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {editingItem ? "Update" : "Create"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
